import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { X } from "react-feather";
import courierService from "../../../../services/courier.service";

const AddressModal = ({ setShowAddAddressModal, createAddress, getAddress }) => {
  const dispatch = useDispatch();
  const { pinloading } = useSelector((state) => state.pincode);
  const [newAddress, setNewAddress] = useState({
    first_name: "",
    last_name: "",
    mobile: "",
    address: "",
    address2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [errors, setErrors] = useState({});

  // Handle input change
  const handleNewAddressChange = async (e) => {
    const { name, value } = e.target;

    // Allow only numbers
    if ((name === "mobile" || name === "pincode") && !/^\d*$/.test(value)) {
      return;
    }
    // Handle pincode separately
    if (name === "pincode") {
      handlePincodeChange(value);
      return;
    }
    setNewAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePincodeChange = async (value) => {
    // Reset if less than 6 digits
    if (value.length < 6) {
      setNewAddress((prev) => ({
        ...prev,
        pincode: value,
        city: "",
        state: "",
      }));

      setErrors((prev) => ({ ...prev, pincode: "" }));
      return;
    }

    // Only proceed if exactly 6 digits
    if (value.length === 6) {
      try {
        const data = await courierService.checkPincode(value);

        setNewAddress((prev) => ({
          ...prev,
          pincode: value,
          city: data.city,
          state: data.state,
        }));

        setErrors((prev) => ({ ...prev, pincode: "" }));
      } catch (error) {
        const errorMessage =
          error?.message || error?.data?.message || "Invalid pincode";
        setNewAddress((prev) => ({
          ...prev,
          pincode: value,
          city: "",
          state: "",
        }));
        setErrors((prev) => ({
          ...prev,
          pincode: errorMessage,
        }));
        toast.error(errorMessage);
      }
    }
  };

  // Form validation
  const validateAddressForm = () => {
    const validationErrors = {};

    if (!newAddress.first_name.trim())
      validationErrors.first_name = "First name is required";

    if (!newAddress.last_name.trim())
      validationErrors.last_name = "Last name is required";

    if (!/^\d{10}$/.test(newAddress.mobile))
      validationErrors.mobile = "Valid 10-digit mobile required";

    if (!/^\d{6}$/.test(newAddress.pincode))
      validationErrors.pincode = "Valid 6-digit PIN required";

    if (!newAddress.address.trim())
      validationErrors.address = "Address required";

    if (!newAddress.city.trim())
      validationErrors.city = "City required";

    if (!newAddress.state.trim())
      validationErrors.state = "State required";

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  // Submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateAddressForm()) return;
    dispatch(createAddress(newAddress)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(getAddress());
        toast.success("Address Added Successfully");
        setShowAddAddressModal(false);
      }
    });
  };

  return (

    <div className="modal-overlay">
      <div className="side-modal">
        <button
          className="close-btn"
          onClick={() => setShowAddAddressModal(false)}
        >
          <X size={20} />
        </button>

        <h3>Add New Address</h3>

        <form onSubmit={handleSubmit}>
          <input
            name="first_name"
            placeholder="First Name"
            value={newAddress.first_name}
            onChange={handleNewAddressChange}
          />
          <p className="error">{errors.first_name}</p>

          <input
            name="last_name"
            placeholder="Last Name"
            value={newAddress.last_name}
            onChange={handleNewAddressChange}
          />
          <p className="error">{errors.last_name}</p>

          <input
            name="mobile"
            placeholder="Mobile"
            maxLength={10}
            value={newAddress.mobile}
            onChange={handleNewAddressChange}
          />
          <p className="error">{errors.mobile}</p>

          <input
            name="pincode"
            placeholder="Pincode"
            maxLength={6}
            value={newAddress.pincode ?? null}
            onChange={handleNewAddressChange}
          />
          {pinloading && <small>Fetching city & state...</small>}
          <p className="error">{errors.pincode}</p>

          <input name="state" placeholder="State" value={newAddress.state} readOnly />
          <p className="error">{errors.state}</p>

          <input name="city" placeholder="City" value={newAddress.city} readOnly />
          <p className="error">{errors.city}</p>

          <input
            name="address"
            placeholder="Street Address 1"
            value={newAddress.address}
            onChange={handleNewAddressChange}
          />
          <p className="error">{errors.address}</p>

          <input
            name="address2"
            placeholder="Street Address 2"
            value={newAddress.address2}
            onChange={handleNewAddressChange}
          />

          <input
            name="landmark"
            placeholder="Landmark"
            value={newAddress.landmark}
            onChange={handleNewAddressChange}
          />

          <button type="submit" disabled={pinloading || errors.pincode}>
            Add Address
          </button>
        </form>
      </div>
    </div>

  );
};
export default AddressModal;